import { render } from "./FrequencySettings.vue?vue&type=template&id=6de578be&scoped=true"
import script from "./FrequencySettings.vue?vue&type=script&lang=js"
export * from "./FrequencySettings.vue?vue&type=script&lang=js"

import "./FrequencySettings.vue?vue&type=style&index=0&id=6de578be&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de578be"]])

export default __exports__